<template>
    <div class="home">
        <HeroHeader @ready="loadedHeroHeader = true" />
        <HighlightsComponent v-if="canLoadHighlights" @loaded="loadedHighlights = true" />
        <WidgetOne v-if="loadedHighlights" />
        <NewsComponent :categories="homeStrips" v-if="loadedHighlights" />
        <VideosComponent v-if="loadedHighlights" />
        <SponsorComponent v-if="loadedHighlights" />

        <router-view></router-view>

    </div>
</template>

<script>
import { useHead } from '@unhead/vue'
import HeroHeader from '@/components/HeroHeader.vue'
import HighlightsComponent from '@/components/Highlights.vue';
import NewsComponent from '@/components/News.vue'
import SponsorComponent from '@/components/Sponsor.vue'
import VideosComponent from '@/components/VideosComponent.vue';
import WidgetOne from '@/components/WidgetOne.vue';
import loadBearing from '../../public/load-bearing.json'

export default {
    name: 'HomeView',
    components: {
        HeroHeader,
        HighlightsComponent,
        NewsComponent,
        SponsorComponent,
        VideosComponent,
        WidgetOne,
    },
    data() {
        return {
            loadedHeroHeader: false,
            loadedHighlights: false,
            homeStrips: loadBearing.terms.category.home_strips,
        }
    },
    methods: {
        ready() {
            if (!this.loaded) {
                return false
            }
            this.$emit('ready');
        }
    },
    computed: {
        canLoadHighlights() {
            return this.loadedHeroHeader;
        },
        loaded() {
            return this.loadedHeroHeader;
        }
    },
    watch: {
        loaded() {
            this.ready()
        },
        $route() {
            this.ready()
        },
    },
    setup() {
        useHead({
            meta: [{
                name: 'this is the name',
                content: 'this is the content',
            }],
        })
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/queries";

.home {
    display: flex;
    flex-direction: column;

    @include media(sm, true) {
        gap: 2rem;
    }

    @include media(sm) {}
}
</style>
